import common from "./common";
// import store from "./store";

var ApiList = {};

// 超商卡设置
ApiList.sbcChargeSetting = function(okCb, failCb) {
  common.Api("/customer/api/sbcCharge/setting.json", {}, okCb, failCb);
};

// 瑞祥商品列表
ApiList.sbcChargeProductList = function(okCb, failCb) {
  common.Api("/customer/api/sbcCharge/productList.json", {}, okCb, failCb);
};

// 瑞祥充值手机历史
ApiList.sbcChargePhoneHistory = function(p = {}, okCb, failCb) {
  common.Api("/customer/api/sbcCharge/phoneHistory.json", p, okCb, failCb);
};

// 直充记录列表
ApiList.sbcChargeRecordList = function(p = {}, okCb, failCb) {
  common.Api("/customer/api/sbcCharge/recordList.json", p, okCb, failCb);
};

// 超商卡记录详情
ApiList.sbcChargeOrderDetail = function(p = {}, okCb, failCb) {
  common.Api("/customer/api/sbcCharge/orderDetail.json", p, okCb, failCb);
};

// 超商卡直充
ApiList.sbcChargeCharge = function(p = {}, okCb, failCb) {
  common.Api("/customer/api/sbcCharge/charge.json", p, okCb, failCb);
};

export default ApiList;



// WEBPACK FOOTER //
// ./src/api/superBusinessCard-api.js